module.exports = __webpack_public_path__ + "static/img/btn_now.a843424f.png";